import { render } from "./BloodPoolingTab.vue?vue&type=template&id=b2d9a3ac"
import script from "./BloodPoolingTab.vue?vue&type=script&lang=js"
export * from "./BloodPoolingTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__